const itsMe = "Nan Chen";

const homepageList = {
    'Nan Chen': 'https://cxxxxxn.github.io/',
    'Fuling Sun': 'https://soundquiet.github.io/',
    'Danqing Shi': 'https://sdq.ai/',
    'Yang Shi': 'https://xiaoyangtao.github.io/', 
    'Xinyue Xu': 'https://ixuxinyue.github.io/', 
    'Siwei Fu': 'https://fusiwei339.bitbucket.io/', 
    'Nan Cao': 'http://nancao.org/',
    'Shunan Guo':'https://www.guoshunan.com/',
    
};

export {homepageList, itsMe} ;